import { isEmpty, pick, prop, propOr } from '../../../utils/fp';
import * as rules from '../../rules';
import * as rules2 from '../../rules2';

// Steps of the vis page's observation model, which selectors/data.js memoizes each on
// its own inputs.

// The custom attributes the model is computed with: the tenant's settings, plus the
// attributes the dataflow shows in tooltips.
export const getDataflowCustomAttributes = (data, customAttributes) => ({
  ...rules2.getDataflowTooltipAttributesIds({ data }, customAttributes),
  ...pick(['prefscale', 'decimals', 'rejectedValueIds'], customAttributes),
});

export const getEnhancedObservations = (data, attributes, dimensions, customAttributes) =>
  rules2.enhanceObservations(dimensions, rules.getObservations({ data }), attributes, {
    customAttributes,
  });

// A dimension with a hierarchical codelist takes its hierarchy, any other one the
// parents of its codelist.
export const hierarchiseDimensions = (dimensions, hierarchies) =>
  dimensions.map(dim => {
    if (isEmpty(propOr({}, dim.id, hierarchies))) {
      return rules2.hierarchiseDimensionWithNativeHierarchy(dim);
    }
    return rules2.applyHierarchicalCodesToDim(prop(dim.id, hierarchies), dim);
  });
